import {
  CommonUtils,
  Factory,
  StandardEntity,
} from '@infodata-group/inf-commons';
import { Absence } from '../model/absence';
import { AbsenceType } from '../model/absence-type';

export class AbsenceFactory implements Factory<Absence> {
  public status: StandardEntity[];
  public types: AbsenceType[];
  public api: string;

  constructor(types: AbsenceType[], status: StandardEntity[], api: string) {
    this.status = status;
    this.types = types;
    this.api = api;
  }

  build(o: any): Absence {
    let type = this.types.find((t) => o.absenceCode === t.id);
    if (!type) {
      type = new AbsenceType(
        o.absenceCode,
        o.absenceCode,
        null,
        '#FAAA0A',
        '#FAAA0A',
      );
    }
    const dateStart = CommonUtils.convertStrToDateTime(
      o.dateStart,
      o.timeStart,
    );
    const dateEnd = CommonUtils.convertStrToDateTime(o.dateEnd, o.timeEnd);
    const absence = new Absence(o.id, type, dateStart, dateEnd);
    absence.informant = o.informant;
    absence.timeStart = o.timeStart;
    absence.timeEnd = o.timeEnd;
    absence.daysDuration = o.hours;
    if (o.day) {
      absence.absenceDays = o.day.map((d) => CommonUtils.convertStrToDate(d));
    }
    if (o.timeSlot) {
      absence.timeSlot = new StandardEntity(o.timeSlot.id, o.timeSlot.label);
    }
    absence.userComment = o.userComment;
    if (o.message) {
      absence.message = o.message;
    }
    absence.justification = o.justification?.join('\n');
    absence.total = o.total;
    const split = o.total.split(':');
    const hours = Number(split[0]);
    const minutes = Number(split[1]);
    const totalMinutes = hours * 60 + minutes;
    absence.totalCentieme = totalMinutes / 60;
    if (o.service) {
      absence.service = new StandardEntity(o.service.id, o.service.label);
    }

    // absence.pay = o.pay;
    if (o.supervisors) {
      absence.supervisors = o.supervisors.map(
        (s) => new StandardEntity(s.id, s.label, 'label'),
      );
    }
    const state = this.status.find((s) => o.state === s.id);
    absence.state = state ?? new StandardEntity(o.state, o.state);
    if (o.user) {
      absence.user = new StandardEntity(o.user.id, o.user.label, 'label');
      absence.userId = o.user.id;
      absence.userLabel = o.user.label;
    }
    absence.absenceTypeCode = o.absenceCode;
    absence.label = o.absenceLabel;
    if (o.absenceType) {
      absence.absenceType = new StandardEntity(
        o.absenceType.id,
        o.absenceType.label,
        'full',
      );
    }
    return absence;
  }

  getApi(): string {
    return this.api;
  }
}
